export const hostGroupTypes = {
  ADD: 'host_group_add',
  CLEAR: 'host_group_clear',
  FIND_ALL: 'host_group_find_all',
  FIND_BY_ID: 'host_group_find_by_id',
  FOUND_BY_HOSTS: 'host_group_find_by_hosts',
  LOADING: 'host_group_loading',
  LOADING_BY_HOSTS: 'host_group_loading_by_hosts',
  UPDATE: 'host_group_update',
};
